/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demobiologie12Inputs */

const en__field_enum_demobiologie12 = /** @type {(inputs: _Field_Enum_Demobiologie12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 - Biowissenschaften`)
};

const de__field_enum_demobiologie12 = /** @type {(inputs: _Field_Enum_Demobiologie12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 - Biowissenschaften`)
};

/**
* | output |
* | --- |
* | "15 - Biowissenschaften" |
*
* @param {_Field_Enum_Demobiologie12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demobiologie12 = /** @type {((inputs?: _Field_Enum_Demobiologie12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demobiologie12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demobiologie12(inputs)
	return de__field_enum_demobiologie12(inputs)
});
export { _field_enum_demobiologie12 as "_field_enum_DEMOBIOLOGIE" }